export default {
  selectIcon: {
    top: 'auto',
    bottom: 'auto',
  },
};
